export default __webpack_public_path__ + "static/media/logo.e3ca6892.svg";